import psHttp, { psHttp$ } from '@patsnap/common-ps-http';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { FreeViewLimitService } from '@/components/no-permission/service/free-view-limit.service';

function newFetch(options, useOb) {
    if (typeof options === 'string') {
        options = {
            url: options,
            method: 'GET',
        };
    }

    if (useOb) {
        return psHttp$(options);
    }
    return psHttp(options)
        .then(resp => resp.data)
        .then(function(res) {
            if (res.errorCode) {
                if (res.errorCode.toString() === '4034') {
                    const freeViewLimitService = injectService(FreeViewLimitService);
                    freeViewLimitService.updateState(true, res.errorMsg);
                }
                throw res;
            }
            return res;
        });
}

export function clearFetchCache() {
    try {
        psHttp.defCache.reset();
        // eslint-disable-next-line no-empty
    } catch (e) {}
}

export default newFetch;
